import { CoverContent } from '@bnnvara/cards/src/components/deprecated/GridCard/CoverContent/CoverContent';
import {
  GridCard,
  LAYOUT_MINIMAL,
  LAYOUT_RECTANGLE,
  LAYOUT_SQUARE,
} from '@bnnvara/cards/src/components/deprecated/GridCard/GridCard';
import { ImageWithTextCard } from '@bnnvara/cards/src/components/ImageWithTextCard/ImageWithTextCard';
import { Author } from '@bnnvara/cards/src/components/shared/Author';
import { CommentCount } from '@bnnvara/cards/src/components/shared/CommentCount';
import { ContentOnImage } from '@bnnvara/cards/src/components/shared/ContentOnImage';
import { HideOnSmallDevices } from '@bnnvara/cards/src/components/shared/HideOnSmallDevices';
import { OnHoverTextEffect } from '@bnnvara/cards/src/components/shared/OnHoverTextEffect';
import { Small } from '@bnnvara/cards/src/components/shared/Small';
import { Title } from '@bnnvara/cards/src/components/shared/Title';
import { formatDate } from '@bnnvara/helpers';
import { CommentIcon } from '@bnnvara/icons/src/components/UserInterfaceIcons/CommentIcon';
import { SlotContent } from '@bnnvara/slot/src/component/SlotContent';
import { Tag } from '@bnnvara/tags';
import PropTypes from 'prop-types';
import React from 'react';
import resizeImageSource from '../../../helpers/resizeImageSource';
import { ThemeTagCard } from '../../Tags/ThemeTagCard';

export const ArticleCard = ({
  title,
  publishDate,
  persons,
  thumbnail,
  commentCount,
  commentsEnabled,
  labelName,
  layout,
  categories,
  theme,
  brand,
  isThemePage,
  subTheme,
}) => {
  const image = thumbnail?.url || '/static/fallbackImages/videofallback.jpg';
  const pubDate =
    publishDate && formatDate(new Date(publishDate), 'dd-MM-yyyy');
  const backgroundImage = resizeImageSource(image, 500, 1);
  const authorName = persons && persons[0] ? persons[0].name : undefined;
  const category = categories && categories[0] ? categories[0].name : undefined;
  const name = brand?.name;
  const isSubTheme = theme ? !!theme.parent : false;
  const hideOnProduction = process.env.NODE_ENV !== 'production';

  if (layout === null) {
    return (
      <ImageWithTextCard
        aria-label={labelName}
        image={{
          alt: title,
          src: backgroundImage,
        }}
      >
        <SlotContent slot="image">
          {commentCount > 0 && commentsEnabled && (
            <CommentCount>
              <CommentIcon />
              {commentCount}
            </CommentCount>
          )}
          <HideOnSmallDevices>
            <ContentOnImage>
              {category && !subTheme && (
                <Tag mb="8px" variant="filled" color="primary">
                  {category}
                </Tag>
              )}
              {subTheme && hideOnProduction && (
                <ThemeTagCard
                  mb="8px"
                  themeSlug={isSubTheme ? theme.parent.slug : theme.slug}
                  textTransform="upperCase"
                >
                  {subTheme.name}
                </ThemeTagCard>
              )}
              <Title>{title}</Title>
              <Small>
                {isThemePage && name && `${name}  • `} {pubDate}
                {authorName && <Author>{authorName}</Author>}
              </Small>
            </ContentOnImage>
          </HideOnSmallDevices>
        </SlotContent>

        <SlotContent slot="text">
          <OnHoverTextEffect>
            {category && !subTheme && (
              <Tag mb="4px" variant="text" color="primary">
                {category}
              </Tag>
            )}
            {subTheme && hideOnProduction && (
              <ThemeTagCard
                mb="4px"
                themeSlug={isSubTheme ? theme.parent.slug : theme.slug}
              >
                {subTheme.name}
              </ThemeTagCard>
            )}
            <Title>{title}</Title>
          </OnHoverTextEffect>
          <Small>
            {isThemePage && name && `${name}  • `} {pubDate}
            {authorName && <Author>{authorName}</Author>}
          </Small>
        </SlotContent>
      </ImageWithTextCard>
    );
  }
  return (
    <GridCard layout={layout} aria-label={labelName}>
      <CoverContent
        title={title}
        pubDate={pubDate}
        backgroundImage={backgroundImage}
        commentCount={commentCount}
        commentsEnabled={commentsEnabled}
      />
    </GridCard>
  );
};

ArticleCard.defaultProps = {
  thumbnail: null,
  commentCount: 0,
  layout: null,
  isThemePage: false,
  name: '',
};

ArticleCard.propTypes = {
  thumbnail: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }),
  brand: PropTypes.shape({
    name: PropTypes.string,
  }),
  title: PropTypes.string.isRequired,
  name: PropTypes.string,
  publishDate: PropTypes.string.isRequired,
  persons: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      slug: PropTypes.string,
    })
  ).isRequired,
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
    })
  ).isRequired,
  theme: PropTypes.shape(),
  subTheme: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
  commentCount: PropTypes.number,
  commentsEnabled: PropTypes.bool,
  labelName: PropTypes.string,
  isThemePage: PropTypes.bool,
  layout: PropTypes.shape({
    mobile: PropTypes.oneOf([LAYOUT_MINIMAL, LAYOUT_SQUARE]),
    tablet: PropTypes.oneOf([LAYOUT_MINIMAL, LAYOUT_RECTANGLE, LAYOUT_SQUARE]),
    desktop: PropTypes.oneOf([LAYOUT_RECTANGLE, LAYOUT_SQUARE]),
  }),
};

export default ArticleCard;
